import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface UserDto {
  loading: boolean;
  data: any[];
}

export const getUsers = createAsyncThunk(
  "users/getUsers",
  async (params: string) => {
    const response: any = await axios.get(`${APIRoutes.USER}?${params}`);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const addNewUser = createAsyncThunk(
  "users/addNewUser",
  async (data: any) => {
    const response: any = await axios.post(APIRoutes.USER, data);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (data: any) => {
    const response: any = await axios.patch(
      `${APIRoutes.USER}/${data?.userId ?? ""}`,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const userToggleBlock = createAsyncThunk(
  "users/userToggleBlock",
  async (data: any) => {
    console.log("==params==", data);
    const response: any = await axios.patch(
      `${APIRoutes.USER_TOGGLE_BLOCK}/${data?.userId ?? ""}`,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id: number) => {
    const response: any = await axios.delete(`${APIRoutes.USER}/${id}`);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

const initialState: UserDto = {
  loading: false,
  data: [],
};

export const users = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data;
      })
      .addCase(getUsers.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default users.reducer;
